// extracted by mini-css-extract-plugin
module.exports = {"shadowInnerTop":"Scrollable_shadowInnerTop__2KTXY","shadowInnerBottom":"Scrollable_shadowInnerBottom__3gUTO"};